import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import { Grid } from '@material-ui/core';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { FaFileExport } from 'react-icons/fa';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { getAllSharedOffer } from './queries';
import { Dialog } from '../../../../components';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import styles from './styles';
import { colors } from '../../../../constants';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);


class TableSharedOffer extends Component {
  state={
    open: false,
    title: '',
    content: '',
    search: '',
    page: 0,
    limit: 15,
    fromDate: null,
    toDate: null,
    typeFilter: '',
  }

  resetFilters = () => {
    this.setState({
      search: '',
      fromDate: null,
      toDate: null,
      typeFilter: '',
      page: 0,
    })
  }

  onOk = () => {
    this.setState({ open: false });
  }

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value });
  }


  /**
   * Prepara los datos ya filtrados y expandidos (una fila por uso) para exportar a CSV.
   */
  prepareDataForCSV = () => {
    const { getAllSharedOffer } = this.props;
    const { search, fromDate, toDate, typeFilter } = this.state;
    let sharedOffers = getAllSharedOffer || [];

    // Orden inicial por fecha de creación del referral code
    sharedOffers = _.orderBy(sharedOffers, obj => Number(obj.createdAt), 'desc');

    // Apply type filter first
    if (typeFilter) {
      sharedOffers = _.filter(sharedOffers, obj => {
        const type = obj.referalCodeType ? obj.referalCodeType.toLowerCase() : '';
        return type === typeFilter.toLowerCase();
      });
    }

    // General search (excluding type and date columns)
    if (search) {
      sharedOffers = _.filter(sharedOffers, function (obj) {
        const titleMatch = obj.offer && obj.offer.title ? obj.offer.title.toLowerCase().includes(search.toLowerCase()) : false;
        const codeMatch = obj.code ? obj.code.toLowerCase().includes(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        const merchantUsername = obj.merchant && obj.merchant.username ? obj.merchant.username.toLowerCase() : '';
        const merchantUsernameMatch = merchantUsername ? merchantUsername.includes(search.toLowerCase()) : false;
        const usageMatch = obj.listUserEnterCode && obj.listUserEnterCode.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return titleMatch || codeMatch || consumerUsernameMatch || merchantUsernameMatch || usageMatch;
      });
    }

    // Expandir para que haya una fila por uso (por transacción)
    let data = [];
    sharedOffers.forEach((sharedOffer) => {
      const ownerUsername = sharedOffer.consumer
        ? sharedOffer.consumer.username
        : (sharedOffer.merchant ? sharedOffer.merchant.username : '');

      if (sharedOffer.listUserEnterCode && sharedOffer.listUserEnterCode.length > 0) {
        sharedOffer.listUserEnterCode.forEach((usage) => {
          // Si hay transacciones, una fila por transacción
          if (usage.transactions && usage.transactions.length > 0) {
            usage.transactions.forEach((tx) => {
              const date = tx.createdAt ? moment(Number(tx.createdAt)) : null;
              data.push({
                Title: sharedOffer.offer ? sharedOffer.offer.title : '',
                Username: ownerUsername,
                Type: sharedOffer.referalCodeType || '',
                'Used By': usage.username || '',
                Date: date ? date.format('MM/DD/YYYY HH:mm') : '',
                usageDate: tx.createdAt,
              });
            });
          } else {
            // Si no hay transacciones, usamos createdAt del usage
            const date = usage.createdAt ? moment(Number(usage.createdAt)) : null;
            data.push({
              Title: sharedOffer.offer ? sharedOffer.offer.title : '',
              Username: ownerUsername,
              Type: sharedOffer.referalCodeType || '',
              'Used By': usage.username || '',
              Date: date ? date.format('MM/DD/YYYY HH:mm') : '',
              usageDate: usage.createdAt,
            });
          }
        });
      } else {
        // Si no hay usos, igual mostramos una fila sin usuario ni fecha
        data.push({
          Title: sharedOffer.offer ? sharedOffer.offer.title : '',
          Username: ownerUsername,
          Type: sharedOffer.referalCodeType || '',
          'Used By': '',
          Date: '',
          usageDate: null,
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(Number(obj.usageDate)).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }

    // Ordenamos por fecha de uso (más reciente primero)
    data = _.orderBy(data, (obj) => {
      if (obj.Date) {
        return moment(obj.Date, 'MM/DD/YYYY HH:mm').valueOf();
      }
      return 0;
    }, 'desc');

    // Remove usageDate from CSV export (keep it only for filtering)
    return data.map(({ usageDate, ...rest }) => rest);
  };

  onExportToCSV = () => {
    if (this.csvLinkRef) {
      this.csvLinkRef.link.click();
    }
  }

  _renderToolBar = () => {
    const { classes } = this.props;
    const { search, fromDate, toDate, typeFilter } = this.state;
    const totalRows = this.prepareDataForCSV().length;
    return (
      <>
      <div className={classes.searchWrapper}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CustomInput
            formControlProps={{
              className: `${classes.margin} ${classes.search}`,
            }}
            inputProps={{
              value: search,
              onChange: this.onSearch,
              placeholder: 'Search',
              inputProps: {
                'aria-label': 'Search',
              },
            }}
          />
          <Button disabled>
            <Search />
          </Button>
          <FormControl style={{ minWidth: 120 }}>
            <InputLabel shrink>Type</InputLabel>
            <Select
              value={typeFilter}
              onChange={(e) => this.setState({ typeFilter: e.target.value })}
              displayEmpty
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="merchant">Merchant</MenuItem>
              <MenuItem value="consumer">Consumer</MenuItem>
            </Select>
          </FormControl>
          <Button variant="contained" color="primary" className={classes.button} onClick={this.onExportToCSV}>
            <Typography component="p" className={classes.text}>Export</Typography>
            <FaFileExport color="#ffffff" size={16} />
          </Button>
          <CSVLink
            data={this.prepareDataForCSV()}
            filename={`shared-offers-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
            style={{ display: 'none' }}
            ref={(r) => { this.csvLinkRef = r; }}
          >
            Export
          </CSVLink>
        </div>
        <Typography component="p" style={{ fontSize: '14px', alignSelf: 'center' }}>
          Rows: {totalRows}
        </Typography>
      </div>
      <div>
      <Typography variant="body1" className={classes.filterLabel}>Date Filter</Typography>
      <Grid key="date-filter" container>
        <Grid key="from" container item xs={12} md={8}>
          <Grid item xs={12} sm={6}>
            <InlineDatePicker
              // keyboard
              label="From"
              id="date-from"
              onChange={(date) => this.setState({ fromDate: date })}
              format="yyyy-MM-dd"
              value={fromDate}
            />
          </Grid>
          <Grid key="to" item xs={12} sm={6}>
            <InlineDatePicker
              // keyboard
              label="To"
              id="date-to"
              onChange={(date) => this.setState({ toDate: date })}
              format="yyyy-MM-dd"
              value={toDate}
            />
          </Grid>
        </Grid>
        <Grid key="reset-date-filter" container item xs={12} md={4}>
          <Button variant="contained" color="primary" className={classes.button} onClick={this.resetFilters}>
            Reset
          </Button>
        </Grid>
      </Grid>
    </div>
    </>
      
    );
  }

  render() {
    const { classes, getAllSharedOffer } = this.props;
    let sharedOffers = getAllSharedOffer || [];
    sharedOffers = _.orderBy(sharedOffers, obj => Number(obj.createdAt), 'desc');
    
    const {
      title, content, open, search, page, limit, fromDate, toDate, typeFilter
    } = this.state;

    // Apply type filter first
    if (typeFilter) {
      sharedOffers = _.filter(sharedOffers, obj => {
        const type = obj.referalCodeType ? obj.referalCodeType.toLowerCase() : '';
        return type === typeFilter.toLowerCase();
      });
    }

    // General search (excluding type and date columns)
    try {
      if (search) {
        sharedOffers = _.filter(sharedOffers, function (obj) {
          const titleMatch = obj.offer && obj.offer.title ? obj.offer.title.toLowerCase().includes(search.toLowerCase()) : false;
          const codeMatch = obj.code ? obj.code.toLowerCase().includes(search.toLowerCase()) : false;
          const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
          const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
          const merchantUsername = obj.merchant && obj.merchant.username ? obj.merchant.username.toLowerCase() : '';
          const merchantUsernameMatch = merchantUsername ? merchantUsername.includes(search.toLowerCase()) : false;
          const usageMatch = obj.listUserEnterCode && obj.listUserEnterCode.some(usage => 
            usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
          );
          return titleMatch || codeMatch || consumerUsernameMatch || merchantUsernameMatch || usageMatch;
        });
      }
    } catch (error) {
      console.log('Filtered error: ',error)
    }

    // Expandir para que haya una fila por uso (por transacción)
    let data = [];
    sharedOffers.forEach((sharedOffer) => {
      const ownerUsername = sharedOffer.consumer
        ? sharedOffer.consumer.username
        : (sharedOffer.merchant ? sharedOffer.merchant.username : '');

      if (sharedOffer.listUserEnterCode && sharedOffer.listUserEnterCode.length > 0) {
        sharedOffer.listUserEnterCode.forEach((usage) => {
          if (usage.transactions && usage.transactions.length > 0) {
            usage.transactions.forEach((tx) => {
              data.push({
                ...sharedOffer,
                ownerUsername,
                usageUsername: usage.username,
                usageDate: tx.createdAt,
              });
            });
          } else {
            data.push({
              ...sharedOffer,
              ownerUsername,
              usageUsername: usage.username,
              usageDate: usage.createdAt,
            });
          }
        });
      } else {
        data.push({
          ...sharedOffer,
          ownerUsername,
          usageUsername: '',
          usageDate: null,
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(Number(obj.usageDate)).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }

    // Ordenamos por fecha de uso (más reciente primero)
    data = _.orderBy(data, (obj) => {
      if (obj.usageDate) {
        return moment(Number(obj.usageDate)).valueOf();
      }
      return 0;
    }, 'desc');

    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Dialog
          title={title}
          content={content}
          open={open}
          onOk={() => this.onOk()}
        />
        {this._renderToolBar()}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell align="right" className={classes.columnRow}>Title</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Username</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Type</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Used By</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Date</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * limit, page * limit + limit).map((row) => {
                return (
                  <TableRow className={classes.row} key={row.id}>
                    <CustomTableCell component="th" scope="row">
                      {row.offer.title}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.ownerUsername}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.referalCodeType || '-'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageUsername || '-'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageDate ? moment(Number(row.usageDate)).format("MM/DD/YYYY HH:mm") : '-'}
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={data.length}
            rowsPerPage={limit}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

// Mark: default props
TableSharedOffer.defaultProps = {
  classes: {},
  getAllSharedOffer: [],
};

// Mark: PropsType
TableSharedOffer.propTypes = {
  classes: PropTypes.object,
  getAllSharedOffer: PropTypes.array,
};

// Mark: Map data grapql to props
const AllReferralCodeByAdmin = graphql(getAllSharedOffer, {
  props: ({ data }) => ({
    loading: data.loading,
    getAllSharedOffer: data.getAllSharedOffer,
  }),
});


export default withStyles(styles)(compose(AllReferralCodeByAdmin)(TableSharedOffer));
